import { useQueryClient } from "@tanstack/react-query";
import useFcmCounts from "../../../hooks/fcm/use-fcm-counts";
import useFcmEvents from "../FcmProvider";

type FcmEventListenerProps = {
  onChatNotification?: (message: any) => void;
};

/**
 * Hook to listen to firebase sms notifications
 * @description useFcmSmsEventListener is a hook that listens to firebase sms notifications and updates the sms count
 *
 * @see useFcmEvents for more details about the firebase notifications wrapper for loose coupling of the code
 *
 * @returns [chatCount, setChatCount]
 *
 * @author Rajkumar Rathod
 */
const useFcmChatEventListener = ({
  onChatNotification,
}: FcmEventListenerProps) => {
  const [chatCount, setChatCount] = useFcmCounts("chat");
  const queryClient = useQueryClient();

  /** listen to firebase sms notifications */
  useFcmEvents((message: any) => {
    if (!message?.notification_type) return;

    if (message?.notification_type === "view-chat") {
      setChatCount("chat", message?.unread_count ?? 0);
      /**
       * inavlidate to show the updated count in conversation list real-time
       */
      queryClient.invalidateQueries({ queryKey: ["conversation-list"] });

      onChatNotification?.(message);
    }
  });

  return [chatCount, setChatCount];
};

export default useFcmChatEventListener;
